module.exports = __webpack_public_path__ + "assets/images/extra-03.6a7f96ed1ccffeeaf8a3bb11be85837c.svg";